import { api } from "../../../infra/api";
import { Paginate } from "../../../infra/paginate";
import { URLS } from "../../../infra/URLS";
import { Contatos } from "../types";

export default async function getContatos(search?: string, page = 1) {
  const { data } = await api.get<Paginate<Contatos>>(
    `${URLS.CONTATO_API}`, {
      params: { page, search }
    }
  );

  return data;
}

export async function getContato(contatoId: any) {
  const result = await api.get(`${URLS.CONTATO_API}/${contatoId}`)
  .then((resp => resp.data));
  return result;
}

export async function getAllContatos(search?: string) {
  const size = await api
    .get(`${URLS.CONTATO_API}`)
    .then((resp) => resp.data.meta);

  const resultJson = await api
    .get(
      `${URLS.CONTATO_API}?${search ? "search" : "limit"}=${
        search ? search : size.totalItems
      }`
    )
    .then((resp) => resp.data.items);

  const result = resultJson.map((contato: Contatos) => ({
    key: contato.ContatoId,
    Nome: contato.Nome + " " + contato.Sobrenome,
    Email: contato.Email,
    Telefone: contato.TelefoneEscritorio,
    CodigoABS: contato.CodigoABS,
    Cliente: contato.ClienteNome,
    Id: contato.ContatoId,
  }));

  return result;
}
